/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/modules/ed-cart-upsell.js":
/*!******************************************!*\
  !*** ./src/js/modules/ed-cart-upsell.js ***!
  \******************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var EdCartUpsell = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdCartUpsell, _HTMLElement);

  var _super = _createSuper(EdCartUpsell);

  function EdCartUpsell() {
    _classCallCheck(this, EdCartUpsell);

    return _super.apply(this, arguments);
  }

  _createClass(EdCartUpsell, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();

      this._attachListeners();

      this._updateUpsell();

      console.log('EdCartUpsell initiated');
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.wrapperEl = this.querySelector('.ed-cart-upsell-wrapper');
      this.imageEl = this.querySelector('.upsell-product-image');
      this.titleEl = this.querySelector('.upsell-product-title');
      this.priceEl = this.querySelector('.upsell-product-price');
      this.unitPriceEl = this.querySelector('.upsell-product-unit-price');
      this.variantWrapperEl = this.querySelector('.upsell-variant-wrapper');
      this.variantSelectEl = this.querySelector('.upsell-variant-select');
      this.addButtonEl = this.querySelector('.upsell-add-button');
      this.scriptEl = this.querySelector('script[data-cart]');
      this.cart = JSON.parse(this.scriptEl.textContent).cart;
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this = this;

      if (this.variantSelectEl) {
        this.variantSelectEl.addEventListener('change', this._onVariantChange.bind(this));
      }

      if (this.addButtonEl) {
        this.addButtonEl.addEventListener('click', function (event) {
          event.preventDefault();

          _this._onAddToCart();
        });
      }
    }
  }, {
    key: "_updateUpsell",
    value: function _updateUpsell() {
      var _this2 = this;

      try {
        var cart = this.cart;

        if (!cart || !cart.items || cart.items.length === 0) {
          this.wrapperEl.style.display = 'none';
          return;
        }

        var upsellItemCount = cart.items.filter(function (item) {
          return item.properties && item.properties._upsellItem === 'true';
        }).length;

        if (upsellItemCount >= 3) {
          this.wrapperEl.style.display = 'none';
          return;
        }

        var firstCartItem = cart.items[cart.items.length - 1];
        var firstProductId = firstCartItem.product_id || firstCartItem.id;

        this._fetchRecommendations(firstProductId).then(function (recommendedProducts) {
          // Filter out any recommended products already in the cart
          var cartProductIds = cart.items.map(function (item) {
            return item.product_id || item.id;
          });
          var firstAvailableProduct = recommendedProducts.find(function (p) {
            return !cartProductIds.includes(p.id);
          });

          if (!firstAvailableProduct) {
            _this2.wrapperEl.style.display = 'none';
            return null;
          }

          _this2._currentRecommendedProduct = firstAvailableProduct;
          return _this2._populateUpsell();
        }).then(function () {
          if (_this2._currentRecommendedProduct) {
            _this2.wrapperEl.style.display = 'block';
          }
        })["catch"](function (e) {
          console.error('Error updating upsell:', e);
          _this2.wrapperEl.style.display = 'none';
        });
      } catch (e) {
        console.error('Error updating upsell:', e);
        this.wrapperEl.style.display = 'none';
      }
    }
  }, {
    key: "_populateUpsell",
    value: function _populateUpsell() {
      var _this3 = this;

      var product = this._currentRecommendedProduct;

      if (!product) {
        return Promise.resolve();
      }

      this.imageEl.src = product.featured_image;
      this.titleEl.textContent = product.title;
      this.titleEl.href = product.url;
      this.priceEl.textContent = theme.Currency.formatMoney(product.price, theme.settings.moneyFormat); // fetch full product data for variants/unit price

      return this._fetchProductData(product.handle).then(function (productData) {
        _this3.productData = productData;
        var variants = productData.variants || [];

        if (variants.length > 1) {
          _this3.variantWrapperEl.style.display = 'block';
          _this3.variantSelectEl.innerHTML = '';
          var firstAvailableVariantId = null;
          variants.forEach(function (variant) {
            var opt = document.createElement('option');
            opt.value = variant.id;
            opt.textContent = "".concat(variant.title, " - ").concat(theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat));

            if (!variant.available) {
              opt.disabled = true;
            } else if (firstAvailableVariantId === null) {
              firstAvailableVariantId = variant.id;
            }

            _this3.variantSelectEl.appendChild(opt);
          });

          if (firstAvailableVariantId) {
            _this3.variantSelectEl.value = firstAvailableVariantId;
            _this3._selectedVariantId = firstAvailableVariantId;
          } else {
            _this3._selectedVariantId = _this3.variantSelectEl.options[0].value;
          }
        } else {
          _this3.variantWrapperEl.style.display = 'none';

          if (variants.length === 1) {
            // Single variant
            if (!variants[0].available) {
              _this3.addButtonEl.disabled = true;
            }

            _this3._selectedVariantId = variants[0].id;
          } else {
            // Edge case: no variant array, use product ID
            _this3._selectedVariantId = product.id;
          }
        }

        _this3._updateUnitPriceDisplay();
      });
    }
  }, {
    key: "_onVariantChange",
    value: function _onVariantChange(event) {
      this._selectedVariantId = event.target.value;

      this._updateVariantInfo();
    }
  }, {
    key: "_updateVariantInfo",
    value: function _updateVariantInfo() {
      var _this4 = this;

      if (!this._selectedVariantId || !this.productData) return;
      var variant = this.productData.variants.find(function (v) {
        return v.id == _this4._selectedVariantId;
      });
      if (!variant) return; // Update the main price element with the selected variant's price

      this.priceEl.textContent = theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat);

      this._updateUnitPriceDisplay();
    }
  }, {
    key: "_updateUnitPriceDisplay",
    value: function _updateUnitPriceDisplay() {
      var _this5 = this;

      if (!this._selectedVariantId || !this.productData) {
        this.unitPriceEl.style.display = 'none';
        return;
      }

      var variant = this.productData.variants.find(function (v) {
        return v.id == _this5._selectedVariantId;
      });

      if (!variant) {
        this.unitPriceEl.style.display = 'none';
        return;
      }

      if (variant.unit_price && variant.unit_price_measurement) {
        var unitPrice = theme.Currency.formatMoney(variant.unit_price, theme.settings.moneyFormat);
        var measurement = variant.unit_price_measurement;
        this.unitPriceEl.textContent = "".concat(unitPrice, "/").concat(measurement.reference_value).concat(measurement.reference_unit);
        this.unitPriceEl.style.display = 'block';
      } else {
        this.unitPriceEl.style.display = 'none';
      }
    }
  }, {
    key: "_onAddToCart",
    value: function _onAddToCart() {
      if (!this._selectedVariantId) return;
      var variantId = this._selectedVariantId;

      this._addToCart(variantId, 1, {
        _upsellItem: 'true'
      }).then(function () {
        window.location.reload();
      })["catch"](function (e) {
        console.error('Error adding upsell to cart:', e);
      });
    }
  }, {
    key: "_fetchRecommendations",
    value: function _fetchRecommendations(productId) {
      var url = "".concat(window.Shopify.routes.root, "recommendations/products.json?product_id=").concat(productId, "&intent=related");
      return fetch(url).then(function (response) {
        if (!response.ok) {
          throw new Error('Failed to fetch recommendations');
        }

        return response.json();
      }).then(function (data) {
        return data.products || [];
      });
    }
  }, {
    key: "_fetchProductData",
    value: function _fetchProductData(handle) {
      return fetch("/products/".concat(handle, ".js")).then(function (response) {
        if (!response.ok) {
          throw new Error('Failed to fetch product data');
        }

        return response.json();
      });
    }
  }, {
    key: "_addToCart",
    value: function _addToCart(id, quantity) {
      var properties = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: id,
          quantity: quantity,
          properties: properties
        })
      }).then(function (response) {
        if (!response.ok) {
          throw new Error('Failed to add to cart');
        }

        return response.json();
      });
    }
  }]);

  return EdCartUpsell;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define('ed-cart-upsell', EdCartUpsell);

/***/ }),

/***/ "./src/js/modules/ed-featured-product.js":
/*!***********************************************!*\
  !*** ./src/js/modules/ed-featured-product.js ***!
  \***********************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var EdFeaturedProduct = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdFeaturedProduct, _HTMLElement);

  var _super = _createSuper(EdFeaturedProduct);

  function EdFeaturedProduct() {
    _classCallCheck(this, EdFeaturedProduct);

    return _super.apply(this, arguments);
  }

  _createClass(EdFeaturedProduct, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();

      this._attachListeners();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.variantSelect = this.querySelector('#ed-variant-select');
      this.addToCartButton = this.querySelector('.ed-add-to-cart');
      this.priceElement = this.querySelector('[data-featured-product-price]');
      this.comparePriceElement = this.querySelector('.ed-featured-product__compare-price'); // Parse product data

      var productDataScript = this.querySelector('script[type="application/json"].product-data');

      if (productDataScript) {
        this.productData = JSON.parse(productDataScript.innerHTML);
      } // Parse shop data


      var shopDataScript = this.querySelector('script[type="application/json"].shop-data');

      if (shopDataScript) {
        this.shopData = JSON.parse(shopDataScript.innerHTML);
      } // Set initial variant ID on the Add to Cart button


      if (this.variantSelect) {
        this.addToCartButton.setAttribute('data-variant-id', this.variantSelect.value);
      } else {
        this.addToCartButton.setAttribute('data-variant-id', this.querySelector('#ed-variant-select').value);
      }
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this = this;

      if (this.variantSelect) {
        this.variantSelect.addEventListener('change', function (event) {
          _this._onVariantChange(event);
        });
      }

      if (this.addToCartButton) {
        this.addToCartButton.addEventListener('click', function (event) {
          _this._onAddToCart(event);
        });
      }
    }
  }, {
    key: "_onVariantChange",
    value: function _onVariantChange(event) {
      var selectedVariantId = event.target.value;

      if (this.productData) {
        var selectedVariant = this.productData.variants.find(function (variant) {
          return variant.id == selectedVariantId;
        });

        if (selectedVariant) {
          // Update price
          this.priceElement.innerText = this._formatMoney(selectedVariant.price); // Update compare at price

          if (selectedVariant.compare_at_price && selectedVariant.compare_at_price > selectedVariant.price) {
            this.comparePriceElement.innerHTML = '<s>' + this._formatMoney(selectedVariant.compare_at_price) + '</s>';
            this.comparePriceElement.style.display = 'block';
          } else {
            this.comparePriceElement.style.display = 'none';
          } // Update Add to Cart button data attribute


          this.addToCartButton.setAttribute('data-variant-id', selectedVariantId);
        }
      }
    }
  }, {
    key: "_onAddToCart",
    value: function _onAddToCart(event) {
      var selectedVariantId = this.addToCartButton.getAttribute('data-variant-id');

      if (selectedVariantId) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: parseInt(selectedVariantId, 10),
              quantity: 1
            }]
          })
        }).then(function (response) {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }

          return response.json();
        }).then(function (data) {
          window.location.href = '/cart';
        })["catch"](function (error) {
          console.error('Error adding item to cart:', error);
        });
      }
    }
  }, {
    key: "_formatMoney",
    value: function _formatMoney(cents) {
      var currency = this.shopData && this.shopData.currency ? this.shopData.currency : 'EUR';
      return (cents / 100).toLocaleString(undefined, {
        style: 'currency',
        currency: currency
      });
    }
  }]);

  return EdFeaturedProduct;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define('ed-featured-product', EdFeaturedProduct);

/***/ }),

/***/ "./src/js/modules/ed-sticky-atc.js":
/*!*****************************************!*\
  !*** ./src/js/modules/ed-sticky-atc.js ***!
  \*****************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var StickyAddToCartBar = /*#__PURE__*/function (_HTMLElement) {
  _inherits(StickyAddToCartBar, _HTMLElement);

  var _super = _createSuper(StickyAddToCartBar);

  function StickyAddToCartBar() {
    _classCallCheck(this, StickyAddToCartBar);

    return _super.apply(this, arguments);
  }

  _createClass(StickyAddToCartBar, [{
    key: "active",
    get:
    /** GETTERS AND SETTERS **/
    function get() {
      return this.getAttribute('active');
    }
  }, {
    key: "setActive",
    value: function setActive(value) {
      this.setAttribute('active', value);
    }
  }, {
    key: "vSelectType",
    get: function get() {
      return this.getAttribute('vselect-type');
    }
  }, {
    key: "setProductAvailability",
    value: function setProductAvailability(value) {
      this.setAttribute('product-available', value);
    }
    /** END GETTERS AND SETTERS **/

  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      /** SETTINGS **/
      this.observerType = this.getAttribute('observer-type');

      this._attachSelectors();

      this._attachListeners();

      this.renderAddToCartButton();
      this.renderPrices();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.btnAddToCart = this.querySelector('[data-ed-atc-btn]');
      this.stickyPrice = this.querySelector('[data-ed-product-price]'); // get default data, as we clone elements from default to the sticky banner

      this.defaultAtcButton = document.querySelector('[data-add-to-cart]');
      this.defaultPrice = document.querySelector('[data-product-price]');
      this.defaultComparePrice = document.querySelector('[data-compare-price]');
      this.defaultQtyContainer = document.querySelector('[data-quantity-selector]');
      this.stickyQtyContainer = this.querySelector('.sticky-atc-quantity-selector');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this = this;

      this.btnAddToCart.addEventListener('click', this.onAddToCart.bind(this));
      this.observeElement(this.defaultAtcButton);
      document.addEventListener('variant:change', this.onVariantChange.bind(this)); // TODO: UPDATE

      if (this.defaultQtyContainer && this.stickyQtyContainer) {
        this.defaultQtyInput = this.defaultQtyContainer.querySelector("input[name='quantity']");
        this.stickyQtyInput = this.stickyQtyContainer.querySelector("input[name='quantity']");

        if (this.defaultQtyInput && this.stickyQtyInput) {
          // Listen for both "input" and "change" events on the default quantity input
          ["input", "change"].forEach(function (eventName) {
            _this.defaultQtyInput.addEventListener(eventName, function () {
              if (_this.stickyQtyInput.value !== _this.defaultQtyInput.value) {
                _this.stickyQtyInput.value = _this.defaultQtyInput.value;
              }
            });
          }); // When the sticky input changes, update the default input

          this.stickyQtyInput.addEventListener("input", function () {
            if (_this.defaultQtyInput.value !== _this.stickyQtyInput.value) {
              _this.defaultQtyInput.value = _this.stickyQtyInput.value;
            }
          }); // Add event listeners for the sticky plus/minus buttons

          var stickyMinusButton = this.stickyQtyContainer.querySelector(".js-qty__adjust--minus");
          var stickyPlusButton = this.stickyQtyContainer.querySelector(".js-qty__adjust--plus");

          if (stickyMinusButton) {
            stickyMinusButton.addEventListener("click", function () {
              var current = parseInt(_this.stickyQtyInput.value, 10) || 1;
              var min = parseInt(_this.stickyQtyInput.getAttribute("min"), 10) || 1;

              if (current > min) {
                _this.stickyQtyInput.value = current - 1;

                _this.stickyQtyInput.dispatchEvent(new Event("input"));
              }
            });
          }

          if (stickyPlusButton) {
            stickyPlusButton.addEventListener("click", function () {
              var current = parseInt(_this.stickyQtyInput.value, 10) || 1;
              _this.stickyQtyInput.value = current + 1;

              _this.stickyQtyInput.dispatchEvent(new Event("input"));
            });
          } // Poll for changes on the default quantity input that occur programmatically


          var lastDefaultValue = this.defaultQtyInput.value;
          setInterval(function () {
            if (_this.defaultQtyInput.value !== lastDefaultValue) {
              lastDefaultValue = _this.defaultQtyInput.value;

              if (_this.stickyQtyInput.value !== lastDefaultValue) {
                _this.stickyQtyInput.value = lastDefaultValue;
              }
            }
          }, 200);
        }
      }
    }
  }, {
    key: "renderPrices",
    value: function renderPrices() {
      var _this2 = this;

      // Wait for the next animation frame so that the default prices are updated.
      requestAnimationFrame(function () {
        var defaultProductPrice = document.querySelector('[data-product-price]');
        var defaultComparePrice = document.querySelector('[data-compare-price]');
        var priceHTML = ''; // Only include the compare price if it exists and is visible.

        if (defaultComparePrice && defaultComparePrice.offsetParent !== null) {
          priceHTML += defaultComparePrice.outerHTML;
        }

        if (defaultProductPrice) {
          priceHTML += defaultProductPrice.outerHTML;
        }

        if (_this2.stickyPrice) {
          _this2.stickyPrice.innerHTML = priceHTML;
        }
      });
    }
  }, {
    key: "renderAddToCartButton",
    value: function renderAddToCartButton() {
      this.btnAddToCart.innerHTML = '';
      this.btnAddToCart.appendChild(this.defaultAtcButton.cloneNode(true));
    }
  }, {
    key: "onVariantChange",
    value: function onVariantChange(e) {
      this.defaultPrice = document.querySelector('[data-product-price]');
      this.defaultAtcButton = document.querySelector('[data-add-to-cart]');
      this.renderPrices();
      this.renderAddToCartButton();
    }
  }, {
    key: "onAddToCart",
    value: function onAddToCart(e) {
      e.preventDefault();
      e.stopPropagation();
      this.defaultAtcButton.click();
    }
    /** INTERSECTION HANDLING **/

  }, {
    key: "observeElement",
    value: function observeElement() {
      var observer;

      if (this.observerType === 'not-visible') {
        observer = new IntersectionObserver(this.handleIntersection.bind(this));
      } else {
        observer = new IntersectionObserver(this.handleIntersection.bind(this), {
          threshold: [0, 0.1, 0.25, 0.5, 0.75, 1]
        });
      }

      observer.observe(this.defaultAtcButton);
    }
  }, {
    key: "handleIntersection",
    value: function handleIntersection(entries) {
      var _this3 = this;

      // show sticky bar, whenever not visible
      if (this.observerType === 'not-visible') {
        entries.map(function (entry) {
          if (entry.isIntersecting) {
            // hide sticky bar
            _this3.setActive('false');
          } else {
            // show sticky bar
            _this3.setActive('true');
          }
        });
      } else {
        // show sticky bar, after selector scroll
        var dif = entries[0].boundingClientRect.top;

        if (dif < 0) {
          if (entries[0].isIntersecting) {
            // entered viewport at the top edge, hence scroll direction is up
            this.setActive('true');
          } else {
            // left viewport at the top edge, hence scroll direction is down
            this.setActive('true');
          }
        } else {
          this.setActive('false');
        }
      }
    }
    /** END INTERSECTION HANDLING **/

  }]);

  return StickyAddToCartBar;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define('ed-sticky-add-to-cart-bar', StickyAddToCartBar);

var StickyVariantSelectorDropdown = /*#__PURE__*/function (_HTMLElement2) {
  _inherits(StickyVariantSelectorDropdown, _HTMLElement2);

  var _super2 = _createSuper(StickyVariantSelectorDropdown);

  function StickyVariantSelectorDropdown() {
    var _this4;

    _classCallCheck(this, StickyVariantSelectorDropdown);

    _this4 = _super2.call(this); // selectors

    _this4.selectInput = _this4.querySelector('.select-wrapper select');
    _this4.defaultSelectWrapper = document.querySelector('.variant-input-wrap');

    _this4._attachListeners();

    return _this4;
  }

  _createClass(StickyVariantSelectorDropdown, [{
    key: "_attachListeners",
    value: function _attachListeners() {
      this.selectInput.addEventListener('change', this.onVariantSelect.bind(this));
      document.addEventListener('variant:change', this.onVariantChange.bind(this)); // TODO: UPDATE
    } // when something on the default selectors happen

  }, {
    key: "onVariantChange",
    value: function onVariantChange(e) {
      var variant = e.detail.variant;
      this.selectInput.querySelector('option[value="' + variant.title + '"]').selected = true;
      this.selectInput.value = variant.title;
    }
  }, {
    key: "onVariantSelect",
    value: function onVariantSelect() {
      var targetRadio = this.defaultSelectWrapper.querySelector('input[value="' + this.selectInput.value + '"]');

      if (targetRadio) {
        targetRadio.click();
      } else {
        console.error('No matching variant radio found for value:', this.selectInput.value);
      }
    }
  }]);

  return StickyVariantSelectorDropdown;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define('ed-vselect-dropdown', StickyVariantSelectorDropdown);

var StickyVariantSelectorRadios = /*#__PURE__*/function (_HTMLElement3) {
  _inherits(StickyVariantSelectorRadios, _HTMLElement3);

  var _super3 = _createSuper(StickyVariantSelectorRadios);

  function StickyVariantSelectorRadios() {
    _classCallCheck(this, StickyVariantSelectorRadios);

    return _super3.apply(this, arguments);
  }

  _createClass(StickyVariantSelectorRadios, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();

      this._attachListeners();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.radioFieldset = this.querySelector('.ed-radio-fieldset');
      this.defaultSelectWrapper = document.querySelector('.variant-input-wrap .variant-input');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      this.radioFieldset.addEventListener('change', this.onVariantSelect.bind(this));
      document.addEventListener('variant:change', this.onVariantChange.bind(this)); // TODO: UPDATE
    } // when something on the default selectors happen

  }, {
    key: "onVariantChange",
    value: function onVariantChange(e) {
      var variant = e.detail.variant;
      this.radioFieldset.querySelector('input[value="' + variant.title + '"]').checked = true;
    }
  }, {
    key: "onVariantSelect",
    value: function onVariantSelect() {
      var selectedRadio = this.radioFieldset.querySelector('input:checked');
      this.defaultSelectWrapper.querySelector('input[value="' + selectedRadio.value + '"]').click();
    }
  }]);

  return StickyVariantSelectorRadios;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define('ed-vselect-radios', StickyVariantSelectorRadios);

/***/ }),

/***/ "./src/js/modules/ed-video-component.js":
/*!**********************************************!*\
  !*** ./src/js/modules/ed-video-component.js ***!
  \**********************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var EdVideoThumbnail = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdVideoThumbnail, _HTMLElement);

  var _super = _createSuper(EdVideoThumbnail);

  function EdVideoThumbnail() {
    var _this;

    _classCallCheck(this, EdVideoThumbnail);

    _this = _super.call(this);

    _this._attachSelectors();

    _this._attachListeners(); // ENABLE EXTERNAL POPUP ELEMENT


    if (_this.popUp) {
      document.querySelector('ed-video-popup').setAttribute('enabled', '');
    }

    return _this;
  }

  _createClass(EdVideoThumbnail, [{
    key: "videoSrc",
    get: function get() {
      return this.getAttribute('video-src');
    }
  }, {
    key: "autoPlay",
    get: function get() {
      return this.getAttribute('autoplay');
    }
  }, {
    key: "controls",
    get: function get() {
      return this.getAttribute('controls');
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.popUp = document.querySelector('.video-popup-container');
      this.popUpVideo = this.popUp.querySelector('.video-container'); // video inside of popup

      this.openButton = this.querySelector('.ed-video-opener'); //this.playButton = this.querySelector('.play-btn'); // OPTIONAL SECOND BUTTON

      this.closeButton = this.popUp.querySelector('.btn-close');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      document.addEventListener('keydown', this.closeOnEsc.bind(this));
      this.openButton.addEventListener('click', this.openPopup.bind(this)); //this.playButton.addEventListener('click', this.openPopup.bind(this));
      // click outside
      //this.popUp.addEventListener('click', this.closePopup.bind(this)); -> NEEDS A BUGIF AS CONTROLS ARE CLOSING THE VIDEO

      this.closeButton.addEventListener('click', this.closePopup.bind(this));
    }
  }, {
    key: "openPopup",
    value: function openPopup(e) {
      e.stopPropagation();
      this.createVideo();
      this.popUp.classList.add('open');
      document.documentElement.classList.add('ed-video-popup-open');
    }
  }, {
    key: "closePopup",
    value: function closePopup(e) {
      e.stopPropagation();
      this.popUpVideo.innerHTML = '';
      this.popUp.classList.remove('open');
      document.documentElement.classList.remove('ed-video-popup-open');
    }
  }, {
    key: "closeOnEsc",
    value: function closeOnEsc(e) {
      if (e.key === 'Escape') {
        this.popUpVideo.innerHTML = '';
        document.documentElement.classList.remove('ed-video-popup-open');
        this.popUp.classList.remove('open');
      }
    }
  }, {
    key: "createVideo",
    value: function createVideo() {
      var video = document.createElement('video');
      video.src = this.videoSrc;
      /** settings **/

      video.autoplay = true;
      video.controls = true;

      if (this.autoPlay === 'false') {
        video.autoplay = false;
      }

      if (this.controls === 'false') {
        video.controls = false;
      }

      this.popUpVideo.appendChild(video);
    }
  }]);

  return EdVideoThumbnail;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define('ed-video-thumbnail', EdVideoThumbnail);

var EdVideoPopup = /*#__PURE__*/function (_HTMLElement2) {
  _inherits(EdVideoPopup, _HTMLElement2);

  var _super2 = _createSuper(EdVideoPopup);

  function EdVideoPopup() {
    _classCallCheck(this, EdVideoPopup);

    return _super2.call(this);
  }

  return _createClass(EdVideoPopup);
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define('ed-video-popup', EdVideoPopup);

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
var __webpack_exports__ = {};
/*!**************************!*\
  !*** ./src/js/custom.js ***!
  \**************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _modules_ed_video_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./modules/ed-video-component */ "./src/js/modules/ed-video-component.js");
/* harmony import */ var _modules_ed_video_component__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_video_component__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _modules_ed_featured_product__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./modules/ed-featured-product */ "./src/js/modules/ed-featured-product.js");
/* harmony import */ var _modules_ed_featured_product__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_featured_product__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _modules_ed_cart_upsell__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./modules/ed-cart-upsell */ "./src/js/modules/ed-cart-upsell.js");
/* harmony import */ var _modules_ed_cart_upsell__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_cart_upsell__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _modules_ed_sticky_atc__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./modules/ed-sticky-atc */ "./src/js/modules/ed-sticky-atc.js");
/* harmony import */ var _modules_ed_sticky_atc__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_sticky_atc__WEBPACK_IMPORTED_MODULE_3__);
/*
DO NOT TOUCH THIS FILE OUTSIDE OF /src DIRECTORY
this file gets compiled ./assets/custom.js - make sure to import every module here.
*/




})();

// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
/*!******************************!*\
  !*** ./src/scss/custom.scss ***!
  \******************************/
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin

})();

/******/ })()
;